import React from 'react';
import { ProdutoIntegrado } from '../models/produtos';
import { useMaestroContext } from '../context/MaestroContext';
import { formatarMoeda } from '../utils/formatters';
import { ICONE_PRODUTO, LABEL_PRODUTO } from '../utils/labels';
import RiscoBadge from './RiscoBadge';

const ProdutoCard: React.FC<{ produto: ProdutoIntegrado; onAbrir?: () => void }> = ({ produto, onAbrir }) => {
  const { getEmpresa } = useMaestroContext();
  const empresa = getEmpresa(produto.empresaId);

  const linhas = (() => {
    switch (produto.tipo) {
      case 'MOTOR_CONCILIACAO':
        return [
          ['Contas concluídas', `${produto.contasConcluidas}/${produto.contasTotais}`],
          ['Contas pendentes', String(produto.contasPendentes)],
          ['Contas com divergência', String(produto.contasComDivergencia)],
          ['Diferença a conciliar', formatarMoeda(produto.diferencaAConciliar)],
        ];
      case 'MAPA_RESULTADOS':
        return [
          ['Contas concluídas', `${produto.contasConcluidas}/${produto.contasTotais}`],
          ['Contas pendentes', String(produto.contasPendentes)],
          ['Contas com divergência', String(produto.contasComDivergencia)],
        ];
      case 'REVISOR_CONTABIL':
        return [
          ['Módulos avaliados', `${produto.modulosAvaliados - produto.modulosComFalha}/${produto.modulosAvaliados}`],
          ['Erros', String(produto.erros)],
          ['Alertas', String(produto.alertas)],
          ['Avisos', String(produto.avisos)],
          ['Impacto total estimado', formatarMoeda(produto.impactoTotalEstimado)],
        ];
      case 'WORKFLOW_SOX':
        return [
          ['Itens na fila', String(produto.itensNaFila)],
          ['Em alerta (SLA amarelo)', String(produto.emAlerta)],
          ['Fora do prazo (SLA vermelho)', String(produto.foraDoPrazo)],
        ];
      default:
        return [];
    }
  })();

  const percentual = produto.tipo === 'MOTOR_CONCILIACAO' ? produto.percentualProcessado
    : produto.tipo === 'MAPA_RESULTADOS' ? produto.percentualConcluido
    : produto.tipo === 'WORKFLOW_SOX' ? undefined
    : produto.modulosAvaliados > 0 ? Math.round(((produto.modulosAvaliados - produto.modulosComFalha) / produto.modulosAvaliados) * 100) : 0;

  const achadoCritico = produto.tipo === 'REVISOR_CONTABIL' && produto.erros > 0;

  return (
    <div className='mc-produto-card-container'>
      <button type='button' className='mc-produto-card' onClick={onAbrir} disabled={!onAbrir}>
        <div className='mc-produto-card__topo'>
          <span className='mc-produto-card__icone'><i className={ICONE_PRODUTO[produto.tipo]} /></span>
          <div>
            <strong>{LABEL_PRODUTO[produto.tipo]}</strong>
            <small>{empresa?.nome}</small>
          </div>
          {achadoCritico && <RiscoBadge criticidade='CRITICA' rotulo='Com erros' />}
        </div>
        {percentual !== undefined && (
          <div className='mc-progress'><div className='mc-progress__track'><div style={{ width: `${percentual}%` }} /></div><span>{percentual}%</span></div>
        )}
        <dl className='mc-produto-card__dados'>
          {linhas.map(([rotulo, valor]) => <div key={rotulo}><dt>{rotulo}</dt><dd>{valor}</dd></div>)}
        </dl>
      </button>
    </div>
  );
};

export default ProdutoCard;
